// Module
var code = "<abx-address abx-model=\"vm.model\" abx-on-change=\"vm.handleChange($event)\" abx-disabled=\"vm.disabled || vm.state === $root.COMPONENT_STATE.saving\" abx-on-focus=\"vm.handleFocus()\" abx-on-blur=\"vm.handleBlur({ model: vm.model })\" abx-on-select=\"vm.handleSelect($event)\"></abx-address> ";
// Exports
module.exports = code;